import request from "@/utils/request-poxyadd";
import request1 from "@/utils/request.js";
// 获取用户列表

export function getschools(data) {
  return request1({
    url: "/console/get_orgs_by_parent_id",
    method: "post",
    data
  });
}

export function get_orgs_by_parent_id(data) {
  return request1({
    url: "/console/get_orgs_by_parent_id",
    method: "post",
    data
  });
}
//查询用户详情
export function getschoolsDetail(data) {
  return request1({
    url: "/console/search_orgs_by_creator",
    method: "post",
    data
  });
}
// 删除用户列表
export function delete_org(data) {
  return request1({
    url: "/console/delete_org",
    method: "post",
    data
  });
}
export function getschool(data) {
  return request({
    url: "getschool",
    method: "post",
    data
  });
}
// 这是杨老师改的
// 【脏代码清理】后端已无 getcorp_type 路由，该函数定义注释停用（Navbar.vue、user/index.vue 中的调用链已同步注释）
// export function getcorp_type(data) {
//   return request({
//     url: "getcorp_type",
//     method: "post",
//     data
//   });
// }
export function insert_school(data) {
  return request1({
    url: "/console/create_org",
    method: "post",
    data
  });
}
//编辑
export function update_entity(data) {
  return request1({
    url: "/console/update_entity",
    method: "post",
    data
  });
}
export function get_organization_types(data) {
  return request({
    // url: 'get_corp_type',
    url: "/console/get_organization_types",
    method: "post",
    data
  });
}
export function get_province_city_district(data) {
  return request({
    url: "/console/get_province_city_district",
    method: "post",
    data
  });
}
